import { useContext } from 'react';
import { FilterContextData } from 'contexts/FilterContext';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { isPpaPerfSummaryScreen } from 'config/urls';
import { trackEventMixpanel } from 'utils/mixpanel';
import { GLOBAL_FILTER_RESET_CLICKED } from 'utils/mixpanelEventNames';

/**
 * Global Filter V2 "Reset" — same sequence as Filter.tsx#clearAll minus `setExpandFilterBol`,
 * which only exists to drive V1's second column.
 */
export function useFilterV2Reset(setAttributeTypeExpandClose: Function) {
    const {
        setIdForRestOfComponent,
        setPreviousSelectedAttributesInUI,
        setRecentIdFromAttributeSelection,
        fetchSinglePresetWrapper,
        setVisibleDatePicker,
        setFilterNullError,
        setMultiSelectedTiers,
        setSingleSelectedTier,
        setTempMultiSelectedTiers,
        setTempSingleSelectedTier,
        setPpaGlobalFilterApplied,
        screenName,
    } = useContext(FilterContextData);

    const { appConfig } = useContext(UserContext);
    const profitPoolConfig = getConfig('profitPool', appConfig);
    const defaultTierFilterSelections = profitPoolConfig?.defaultTierFilterSelections || {
        multiSelect: [],
        singleSelect: [],
    };

    return function resetFilter() {
        trackEventMixpanel(GLOBAL_FILTER_RESET_CLICKED);
        if (isPpaPerfSummaryScreen(screenName)) {
            setPpaGlobalFilterApplied(false);
        }
        setIdForRestOfComponent({ dim1: { ids: [] }, dim2: { ids: [] } });
        setPreviousSelectedAttributesInUI({ dim1: ['attr', 'attr'], dim2: ['attr', 'attr'] });
        setRecentIdFromAttributeSelection({ attr: { dim1: { ids: [] }, dim2: { ids: [] } } });
        setAttributeTypeExpandClose('');
        fetchSinglePresetWrapper({}, { isReset: true });
        setVisibleDatePicker(false);
        setFilterNullError(undefined);
        setTempMultiSelectedTiers(defaultTierFilterSelections.multiSelect);
        setTempSingleSelectedTier(defaultTierFilterSelections.singleSelect);
        setMultiSelectedTiers(defaultTierFilterSelections.multiSelect);
        setSingleSelectedTier(defaultTierFilterSelections.singleSelect);
    };
}

export default useFilterV2Reset;
